export default function NoRedirectRoute({ children }) {
  return children;
}
